<template>
  <div class="goods-container">
    <span
      v-if="goodsItem.leftSsuCount > 0 && goodsItem.leftSsuCount <= 10"
      class="remaining-num"
    >
      仅剩{{ goodsItem.leftSsuCount }}份
    </span>
    <div class="goods">
      <img class="img" :src="goodsItem.link" />
      <p class="name">
        {{ goodsItem.goodName }}
      </p>
      <p class="format">
        {{ goodsItem.ssuDesc
        }}{{ goodsItem.price ? ' | ¥' + goodsItem.price : '' }}
      </p>
      <div class="cost-point-wrap">
        <img class="cost-img" src="@/images/integral/jifen@3x.png" />
        <span v-if="goodsItem.leftSsuCount > 0" class="cost-point">{{
          goodsItem.score
        }}</span>
        <span v-else class="cost-point finish">{{ goodsItem.score }}</span>
      </div>
    </div>
    <div class="operator">
      <button
        v-if="goodsItem.leftSsuCount > 0"
        class="submit-btn"
        @click="onPointGoodsExchange(goodsItem)"
      >
        {{
          goodsItem.perMaxNum
            ? `立即兑换(限兑${goodsItem.perMaxNum}份)`
            : '立即兑换'
        }}
      </button>
    </div>
    <img
      v-if="goodsItem.leftSsuCount <= 0"
      class="robbed-img"
      src="@/images/integral/yiqiangguang@3x.png"
    />
  </div>
</template>

<script>
export default {
  props: {
    goodsItem: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    onPointGoodsExchange() {
      this.$emit('pointGoodsExchange', this.goodsItem)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-container {
  background: #ffffff;
  border-radius: 0.2rem; /* 10/50 */
  position: relative;
  width: 100%;
  .goods {
    @include flex-column-center;
    position: relative;
    margin-bottom: 0.62rem;
    padding: 0.1rem 0.1rem 0 0.1rem;
    z-index: 8;
    .img {
      width: 2.26rem; /* 113/50 */
      height: 2.12rem; /* 106/50 */
    }
    .name {
      margin-top: 0.2rem;
      white-space: normal;
      font-size: 0.28rem;
      font-weight: bold;
      color: #333333;
      text-align: center;
    }
    .format {
      margin-top: 0.08rem; /* 4/50 */
      white-space: normal;
      font-size: 0.24rem; /* 12/50 */
      line-height: 0.24rem;
      color: #999999;
      text-align: center;
    }
    .cost-point-wrap {
      @include flex-row-center;
      margin: 0.18rem 0 0.14rem; /* 9/50 */
      .cost-img {
        width: 0.4rem; /* 14/50 */
        height: 0.4rem; /* 14/50 */
        margin-top: -0.02rem;
        margin-right: 0.06rem; /* 3/50 */
      }
      .cost-point {
        font-size: 0.4rem; /* 12/50 */
        color: #333;
        font-weight: bold;
        .finish {
          color: #999999;
        }
      }
    }
    .price {
      margin-top: 0.08rem; /* 4/50 */
      margin-bottom: 0.14rem;
      font-size: 0.24rem; /* 12/50 */
      color: #999999;
      text-decoration: line-through;
    }
  }
  .operator {
    @include flex-row-center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.26rem; /* 13/50 */
    .submit-btn {
      color: #ffffff;
      padding: 0 0.3rem;
      height: 0.56rem; /* 28/50 */
      font-size: 0.24rem; /* 12/50 */
      line-height: 0.24rem; /* 12/50 */
      white-space: nowrap;
      background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
      box-sizing: border-box;
      border-radius: 0.3rem;
    }
  }
  .robbed-img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 7;
    width: 1.5rem; /* 75/50 */
    height: 1.5rem; /* 75/50 */
  }
  .remaining-num {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.08rem 0.16rem;
    font-size: 0.2rem;
    line-height: 0.2rem;
    border-radius: 6px 0 6px 0;
    background-image: linear-gradient(to left, #c59569, #f1c89c);
    z-index: 100;
  }
}
</style>
